<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<!-- <circle cx="12" cy="12" r="12" :fill="fill_color"/> -->
		<path fill-rule="evenodd" clip-rule="evenodd" d="M5.88574 15.9715V18.8882H8.80252L17.4051 10.2857L14.4883 7.3689L5.88574 15.9715ZM19.6606 8.02999C19.8063 7.88466 19.8881 7.68737 19.8881 7.48164C19.8881 7.2759 19.8063 7.07861 19.6606 6.93328L17.8406 5.11321C17.6952 4.96758 17.498 4.88574 17.2922 4.88574C17.0865 4.88574 16.8892 4.96758 16.7439 5.11321L15.3205 6.5366L18.2373 9.45338L19.6606 8.02999V8.02999Z" :fill="fill_color" :fill_opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
